import {useEffect, useState} from "react";
import { apiRequest } from "../../network/apiClient";
import {API_ENDPOINTS} from "../../api/apiEndpoints";

export const useAccDetStatistics = ({leadID}) => {
    const [statCard, setStatCard] = useState([]);
    const [behaviourData, setBehaviourData] = useState([]);
    const [boxPlotsGrossVol, setBoxPlotsGrossVol] = useState([]);
    const [boxPlotsMargin, setBoxPlotsMargin] = useState([]);
    const [boxPlotsSpread, setBoxPlotsSpread] = useState([]);
    const [boxPlotsNetPNL, setBoxPlotsNetPNL] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    useEffect(() =>{
        const fetchData = async () =>{
            try{
                setLoading(true);
                setError(null);
                const queryParams = new URLSearchParams({
                    lead_id: leadID
                })
                const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_ACCOUNTS.STATISTICS}?${queryParams.toString()}`, 'GET');
                setStatCard(result.stat_card);
                setBehaviourData(result.behaviour_data);
                setBoxPlotsGrossVol(result.boxplot_data?.gross_volume_myr);
                setBoxPlotsMargin(result.boxplot_data?.margin);
                setBoxPlotsSpread(result.boxplot_data?.spread);
                setBoxPlotsNetPNL(result.boxplot_data?.net_pnl);
            }catch (error){
                if (error.response?.status === 404) {
                    setError("Data not found");
                } else {
                    console.error("Error fetching data:", error);
                    setError(error);
                }
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [leadID]);

    // console.table(boxPlotsGrossVol);
    return {statCard, behaviourData, boxPlotsGrossVol, boxPlotsMargin, boxPlotsSpread, boxPlotsNetPNL, loading, error};
}